import { Component, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { AppState } from '../../../../app.reducers';
import { Observable } from 'rxjs';
import { getSelectedProperty, getSelectedFiscalYear } from '../../../property/property-store/property.selectors';
import { Router } from '@angular/router';
import { Property } from '../../../property/shared/models';
import { FiscalYear } from 'app/internal/shared/models';
import { combineLatest } from 'rxjs';
import { Plan } from 'app/internal/plans/shared/models';
import { getPlans } from 'app/internal/plans/plans-store/plans.selectors';
import { LoadPlansAction } from 'app/internal/plans/plans-store';
import { PlanRequest } from 'app/internal/plans/shared/models/plan-request';
import { filter } from 'rxjs/operators';
import {
  LoadDisclosurePlanAction,
  LoadFinancialHealthReportAction
} from 'app/internal/reports/redux/reports.actions';
import {
  FinancialHealthReport,
  FinancialHealthReportRequest,
  ReportRequest
} from 'app/internal/reports/shared/models';
import { getDisclosurePlanId, getFinancialHealthReport } from 'app/internal/reports/redux/reports.selectors';
import { SubSink } from 'subsink';
import { SetBackToDashboard } from 'app/internal/component/component-store';

@Component({
  selector: 'sp-dashboard-future',
  templateUrl: './dashboard-future.component.html',
  styleUrls: ['./dashboard-future.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class DashboardFutureComponent implements OnInit, OnDestroy {
  selectedProperty$: Observable<Property>;
  selectedFiscalYear$: Observable<FiscalYear>;
  plans$: Observable<Plan[]>;
  disclosurePlanId$: Observable<string>;
  financialHealthReport$: Observable<FinancialHealthReport>;

  private subs = new SubSink();

  constructor(private store: Store<AppState>,
    private router: Router) {

    this.selectedProperty$ = this.store.pipe(select(getSelectedProperty));
    this.selectedFiscalYear$ = this.store.pipe(select(getSelectedFiscalYear));
    this.plans$ = this.store.pipe(select(getPlans));
    this.disclosurePlanId$ = this.store.pipe(select(getDisclosurePlanId));
    this.financialHealthReport$ = this.store.pipe(select(getFinancialHealthReport));

  }

  ngOnInit() {

    this.subs.sink = combineLatest([this.selectedFiscalYear$, this.selectedProperty$])
      .pipe(filter(([fy, p]) => fy != null && p != null && !fy.requireSetup && fy.isFutureFiscalYear))
      .subscribe(([fiscalYear, property]) => {
        this.store.dispatch(new LoadPlansAction(new PlanRequest(property.propertyId, fiscalYear.year)));
        this.store.dispatch(new LoadDisclosurePlanAction(new ReportRequest(property.propertyId, fiscalYear.year)));
        this.store.dispatch(new LoadFinancialHealthReportAction(new FinancialHealthReportRequest(property.propertyId, fiscalYear.year)));
      });
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  onBackToDashboard() {
    this.store.dispatch(new SetBackToDashboard(true));
  }
}
